import { Injectable } from '@angular/core';
import { HttpRequestService } from 'src/app/shared/services/http-request.service';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  constructor(private httpRes: HttpRequestService) { }

  getEmpDependants(userId) {
    return  this.httpRes.GetRequest('empdependant/getbyempuserid/' + userId).toPromise();
  }

  getPatient(userId) {
    return  this.httpRes.GetRequest('patient/getbyuserid/' + userId).toPromise();
  }
}
